import { Stack, StackProps, Typography } from '@mui/material';

import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import { PlusIcon } from '@/components/icons/PlusIcon';
import { useModalState } from '@/hooks/useModalState';
import { zIndexes } from '@/styles/zIndexes';

export interface LargeTableEmptyStateProps {
  title: string;
  description: string;
  ModalComponent?: React.FC<{ isOpen: boolean; onClose: () => void }>;
  hideButtons?: boolean;
  buttonProps?: Partial<ButtonProps>;
  button2Props?: Partial<ButtonProps>;
  containerProps?: Partial<StackProps>;
  buttonText: string;
  button2Text?: string;
  Button?: React.FC<ButtonProps>;
  Button2?: React.FC<ButtonProps>;
  icon?: React.ReactElement | null;
}

export function LargeTableEmptyState({
  title,
  description,
  buttonText,
  button2Text,
  ModalComponent,
  hideButtons = false,
  buttonProps = {},
  button2Props,
  containerProps = {},
  Button: CustomButton = Button,
  Button2: CustomButton2 = Button,
  icon = null,
}: LargeTableEmptyStateProps) {
  const [{ isModalOpen }, { closeModal, openModal }] = useModalState();

  return (
    <Stack
      // Need to elevate the zIndex a little bit because of some MUI internals
      zIndex={zIndexes.CARD}
      {...containerProps}
      sx={{
        width: '100%',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        p: 4,
        py: 22,
        ...(containerProps?.sx ?? {}),
      }}
    >
      {icon}
      <Typography variant="title-s" sx={{ pb: 1 }}>
        {title}
      </Typography>
      <Typography
        variant="body-xs"
        sx={{ pb: 1.5, maxWidth: 400, textAlign: 'center' }}
      >
        {description}
      </Typography>
      {!hideButtons && (
        <Stack direction="row" spacing={1}>
          <CustomButton
            startIcon={PlusIcon}
            variant="primary"
            size="sm"
            onClick={openModal}
            {...buttonProps}
          >
            {buttonText}
          </CustomButton>
          {button2Props && (
            <CustomButton2 variant="secondary" size="sm" {...button2Props}>
              {button2Text}
            </CustomButton2>
          )}
        </Stack>
      )}
      {ModalComponent && (
        <ModalComponent isOpen={isModalOpen} onClose={closeModal} />
      )}
    </Stack>
  );
}
